export default __webpack_public_path__ + "static/media/mountains-hero-image.28d2570d.jpg";